<template>
  <div class="lds-container">
    <div v-if="visible" class="lds-ring">
      <div :class="size"></div>
      <div :class="size"></div>
      <div :class="size"></div>
      <div :class="size"></div>
    </div>
    <div class="lds-overlay" :class="{ 'is-loading': visible }">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    visible: {
      default: true,
      type: Boolean
    },
    size: {
      default: 'normal',
      type: String
    }
  }
}
</script>
<style lang="stylus" scoped>
.lds-overlay
  visibility visible
.lds-overlay.is-loading
  visibility hidden
.lds-container
  /*position relative*/
.lds-ring
  z-index 1
  display inline-block
  width 32px
  height 32px
  position absolute
  top 50%
  left 50%
  transform translateX(-50%)translateY(-50%)
.lds-ring div
  box-sizing border-box
  display block
  position absolute
  margin 4px
  border 4px solid
  border-color #eebd65 transparent transparent transparent
  border-radius 50%
  animation lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite
  &.normal
    width 32px
    height 32px
  &.large
    width 48px
    height 48px
.lds-ring div:nth-child(1)
  animation-delay -0.45s
.lds-ring div:nth-child(2)
  animation-delay -0.3s
.lds-ring div:nth-child(3)
  animation-delay -0.15s
@keyframes lds-ring
  0%
    transform: rotate(0deg)
  100%
    transform: rotate(360deg)
</style>
